/*
 * Footer steam video: the markup carries the file in data-src and no autoplay, so nothing is
 * downloaded at page load (previously both the mobile and desktop variants fetched the 338 KiB file,
 * even the hidden one). When the footer comes within 400px of the viewport the variant that is
 * actually displayed gets its src and plays; the hidden variant never intersects, so it never loads.
 */
const videos = document.querySelectorAll('video.footer-tea__steam[data-src]');

if (videos.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                return;
            }
            const video = entry.target;
            observer.unobserve(video);
            if (video.offsetParent === null) {
                return;
            }
            video.src = video.dataset.src;
            video.load();
            const playing = video.play();
            if (playing && typeof playing.catch === 'function') {
                playing.catch(() => {});
            }
        });
    }, { rootMargin: '400px 0px' });

    videos.forEach((video) => observer.observe(video));
}
